import { BaseOptionType } from '../types'

type IGetOptionId<Option extends BaseOptionType> = (option?: Option) => IdType

export const areOptionsEqual = <Option extends BaseOptionType>(
  getOptionId: IGetOptionId<Option>,
  currentOption?: Option,
  selectedOption?: Option
) => getOptionId(currentOption) === getOptionId(selectedOption)
